import register from '../../Actions/register';
const { types } = register;

const initialState = {
    registerData:{},
    packageToBuy: ''
};

const registerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_REGISTER_FORM_DATA:
            return {
                ...state,
                registerData: action.data
            };
        case types.SELECT_PACKAGE_TO_BUY:
            return {
                ...state,
                packageToBuy: action.data
            };
        default:
            return state;
    }
}

export default registerReducer;